import React, { useEffect, useState } from 'react';
import 'twin.macro';

const delay = 1000; //1s
let setTimeoutInstance;

export function EventsLoader() {
  const [isExpired, setIsExpired] = useState(true);

  useEffect(() => {
    setIsExpired(false);

    if (setTimeoutInstance) {
      clearTimeout(setTimeoutInstance);
    }
    setTimeoutInstance = setTimeout(() => {
      setIsExpired(true);
    }, delay);
  }, []);

  if (!isExpired) {
    return (
      <div tw="text-lg text-center space-y-4">
        <div tw="h-12 w-full" className="tsh-skeleton" />
        <div tw="h-12 w-full" className="tsh-skeleton" />
        <div tw="h-12 w-full" className="tsh-skeleton" />
        <div tw="h-12 w-full" className="tsh-skeleton" />
        <div tw="h-12 w-full" className="tsh-skeleton" />
      </div>
    );
  }
  return null;
}
